import React, { useState } from "react";
// TODO: Add react-helmet-async when React 19 support is available for SEO meta tags

import "../pages/header.css";
import "../pages/Uploads.css";

import logotypeDark from "../assets/dance_locale_3-200h.png";
import danceLocaleIcon from "../assets/logo_fox_map_pin_v4-600h.png";
import apiClient from "../api/client";

const ForgotPassword = () => {

    const [email, setEmail] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState(""); // "success" or "error"
    const [emailSent, setEmailSent] = useState(false);

    const handleSubmit = async e => {
        e.preventDefault();

        if (!email) {
            setMessage("Please enter your email address.");
            setMessageType("error");
            return;
        }

        setIsLoading(true);
        setMessage("");

        try {
            // Shared client: adds the X-App-Version dev header on localhost/devMode and
            // returns { ok, data } already flattened (never throws on HTTP error).
            const response = await apiClient.post("/api/v2/auth/request-password-reset", { email });

            if (response.ok && response.data?.success) {
                setMessage("If an account with that email exists, a password reset link has been sent.");
                setMessageType("success");
                setEmailSent(true);
            } else {
                setMessage(response.data?.message || "An error occurred. Please try again.");
                setMessageType("error");
            }
        } catch (error) {
            console.error("Forgot password error:", error);
            setMessage("An error occurred. Please try again later.");
            setMessageType("error");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="dashboard-container branded-bg">
                        {/* TODO: Add SEO meta tags when react-helmet-async supports React 19
                Title: "Forgot Password - Dance Locale" */}

            {/* Header */}
            <div data-role="Header" className="home-header-container">
                <header className="home-header">
                    <a href="/" className="home-logo1">
                        <img alt="Dance Locale" src={logotypeDark} className="home-image1" />
                        <span className="nav-wordmark">Dance Localé</span>
                    </a>
                    <div className="home-menu1">
                        <a href="/" className="home-text10" style={{ cursor: "pointer", textDecoration: "none" }}>
                            Home
                        </a>
                        <a href="/faq" className="home-text11" style={{ cursor: "pointer", textDecoration: "none" }}>
                            FAQ
                        </a>
                    </div>
                </header>
            </div>

            {/* Main Content */}
            <div className="dashboard-main">
                <div className="dashboard-content-wrapper" style={{ maxWidth: "500px" }}>
                    <div className="dashboard-header-card">
                        <div style={{ textAlign: "center", marginBottom: "var(--dl-layout-space-unit)" }}>
                            <img
                                src={danceLocaleIcon}
                                alt="Dance Locale"
                                style={{ width: "60px", height: "60px", marginBottom: "var(--dl-layout-space-unit)" }}
                            />
                        </div>

                        <h1 className="admin-console-title">Forgot Password?</h1>
                        <p className="admin-console-description">
                            Enter your email address and we'll send you a link to reset your password.
                        </p>

                        {message && <div className={`admin-console-status ${messageType}`}>{message}</div>}

                        {!emailSent && (
                            <form onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label className="form-label" htmlFor="email">
                                        Email Address
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                        className="form-input"
                                        placeholder="Enter your email address"
                                        required
                                        /* 16px is deliberate: below 16px iOS Safari auto-zooms on focus */
                                        style={{ fontSize: "16px" }}
                                    />
                                </div>

                                <button
                                    type="submit"
                                    className="btn-purple btn-large"
                                    disabled={isLoading}
                                    style={{ width: "100%", marginBottom: "var(--dl-layout-space-unit)" }}>
                                    <span
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "8px",
                                        }}>
                                        {isLoading && <span className="admin-console-spinner"></span>}
                                        {isLoading ? "Sending..." : "Send Reset Link"}
                                    </span>
                                </button>
                            </form>
                        )}

                        {emailSent && (
                            <div style={{ textAlign: "center", marginTop: "var(--dl-layout-space-unit)" }}>
                                <p style={{ marginBottom: "var(--dl-layout-space-unit)" }}>
                                    Check your email for the password reset link.
                                </p>
                                <a
                                    href="/login"
                                    className="btn-purple btn-large"
                                    style={{ width: "100%", display: "block" }}>
                                    Back to Login
                                </a>
                            </div>
                        )}

                        <div style={{ textAlign: "center", marginTop: "var(--dl-layout-space-unit)" }}>
                            <span style={{ color: "var(--dl-color-gray-600)", fontSize: "14px" }}>
                                Remember your password?{" "}
                                <a
                                    href="/login"
                                    style={{
                                        color: "var(--dl-color-hyperlink)",
                                        cursor: "pointer",
                                        textDecoration: "underline",
                                    }}>
                                    Sign In
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
